import { useMutation } from '@tanstack/react-query';
import { api } from '../api/client';
import type { ExplainRequest, ExplainResponse } from '../types';

// 'Explain this in plain language' (spec 11.5): the bounded, marked AI aid. POSTs the on-page bound
// facts plus the engine/intervention to /api/explain, which re-expresses ONLY those via the shared
// adapter (with guardrails), and shows the result beside the brief, never replacing it. Works with
// the flag off (returns the deterministic floor). Ephemeral: re-clicking regenerates, nothing cached.
export default function ExplainThis(facts: ExplainRequest) {
  const m = useMutation<ExplainResponse, Error, void>({ mutationFn: () => api.explain(facts) });
  const res = m.data;
  return (
    <div style={{ marginTop: 10 }}>
      <button
        type="button"
        className="btn ghost"
        style={{ minHeight: 'auto', padding: '4px 10px', fontSize: 12 }}
        onClick={() => m.mutate()}
        disabled={m.isPending}
      >
        {m.isPending ? 'Explaining…' : 'Explain this in plain language'}
      </button>
      {m.isError && <div className="small" style={{ color: 'var(--red)', marginTop: 6 }}>Could not generate an explanation.</div>}
      {res && (
        <div
          className="panel"
          style={{ marginTop: 8, background: 'var(--bg)', borderLeft: `3px solid ${res.source === 'model' ? 'var(--blue)' : 'var(--line)'}` }}
        >
          <div className="small faint" style={{ marginBottom: 4, fontSize: 11 }}>
            {res.source === 'model'
              ? 'Plain-language explanation (an AI aid; the brief and figures beside it stay the version of record)'
              : 'Plain-language explanation'}
          </div>
          <div className="small" style={{ lineHeight: 1.55 }}>{res.explanation}</div>
        </div>
      )}
    </div>
  );
}
